import { z } from 'zod';
import { fieldRubricDimensionSchema } from './field.js';
export const fieldAssessmentAdviceSchema = z.object({
    candidateRevision: z.string(),
    generatedAt: z.string(),
    dimensions: z
        .array(z.object({
        dimension: fieldRubricDimensionSchema,
        rating: z.number().int().min(0).max(4).nullable(),
        rationale: z.string().min(1).max(4000),
        evidenceIds: z.array(z.string()).max(20),
    }))
        .length(10)
        .refine((items) => new Set(items.map((i) => i.dimension)).size === 10, 'Each dimension must appear once'),
    limitations: z.array(z.string().max(2000)).max(20),
});
